import React, { useContext } from "react";
import {
  Layout,
  Avatar,
  Popover,
  Menu,
  theme,
  MenuProps,
  ConfigProvider,
  Drawer,
  Row,
  Col,
  Card,
} from "antd";
// import companylogo1 from "../../images/LogoIcon.svg";
import { UserOutlined } from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../../Context/UserContext";
import companylogo from "../../images/companyLogo.svg";
import companylogo1 from "../../images/companyLogoIcon.svg";
import "./Dashboardlayout.css";
import { useTheme } from "../Context/ThemeContext";
import { ContentUser } from "../../Common/Admin/AdminComponent";
import AssetImg from "../../images/AssetImg.svg";
import { HotkeysProvider } from "react-hotkeys-hook";
import { MenuIcon } from "./Icon";
import adminContext from "../../Context/AdminContext";
const { Header, Sider, Content } = Layout;

type MenuItem = Required<MenuProps>["items"][number];

const MainSuperAdminTable = (props: any) => {
  const { getUser } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated } = useUser();
  const [collapsed, setCollapsed] = React.useState(false);
  const [width, setWidth] = React.useState<any>(window.innerWidth);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [locationUrl, setLocationUrl] = React.useState<string>("");
  const { userData, trigger, getUserdata } = useContext(adminContext);
  const themeData: any = useTheme();
  const { defaultAlgorithm, darkAlgorithm } = theme;

  React.useEffect(() => {
    getUserdata();
  }, [trigger]);

  React.useEffect(() => {
    if (!isAuthenticated()) navigate("/");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  let loginUser = { ...getUser() };

  React.useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  const selectedMenuItem = (key: any) => {
    setOpenDrawer(false);
    navigate(key);
  };

  const forActndInActive = (currentUrl: any) => {
    return locationUrl === currentUrl ? true : false;
  };

  React.useEffect(() => {
    let splittedpath = location.pathname.split("/");
    if (splittedpath[1] && splittedpath[2]) {
      setLocationUrl(`/${splittedpath[1]}/${splittedpath[2]}`);
    } else {
      setLocationUrl(`/${splittedpath[1]}`);
    }
  }, [location]);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }
  const superAdminItems: MenuItem[] = [
    getItem(
      <Link to={"/books/customer"}>Customer</Link>,
      "/books/customer",
      <img
        alt="AssetImg"
        src={AssetImg}
        style={{ height: "20px", width: "20px", marginRight: "12px" }}
      />
    ),
    getItem(
      <Link to={"/books/gst"}>GST</Link>,
      "/books/gst",
      <img
        alt="AssetImg"
        src={AssetImg}
        style={{ height: "20px", width: "20px", marginRight: "12px" }}
      />
    ),
    getItem(
      <Link to={"/books/product"}>Product</Link>,
      "/books/product",
      <img
        alt="AssetImg"
        src={AssetImg}
        style={{ height: "20px", width: "20px", marginRight: "12px" }}
      />
    ),
    // getItem(
    //   <Link to={"/books/Tds"}>TDS</Link>,
    //   "/books/Tds",
    //   <img
    //     alt="AssetImg"
    //     src={AssetImg}
    //     style={{ height: "20px", width: "20px", marginRight: "12px" }}
    //   />
    // ),
    // getItem(
    //   <Link to={"/books/Tcs"}>TCS</Link>,
    //   "/books/Tcs",
    //   <img
    //     alt="AssetImg"
    //     src={AssetImg}
    //     style={{ height: "20px", width: "20px", marginRight: "12px" }}
    //   />
    // ),
  ];
  return (
    <>
      {/* <ConfigProvider theme={{ token: { colorPrimary: "#3d4998" } }}> */}
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: themeData?.themeData?.themeColor ?? "#395cd2",
            fontSize: themeData?.themeData?.fontSize ?? 14,
            borderRadius: themeData?.themeData?.borderRadius ?? 6,
            colorLink: themeData?.themeData?.themeColor,
          },
          algorithm:
            themeData?.themeData?.darkMode === true
              ? darkAlgorithm
              : defaultAlgorithm,
        }}
        componentSize={themeData?.themeData?.componentSize ?? "middle"}
      >
        <Header
          style={{
            padding: 0,
            // backgroundColor:
            height: "55px",
            // borderBottom: "2px solid #eef2fe",
            // borderBottom: "1px solid #E4E8F0",

            // backgroundColor: "white",
            background: themeData.themeData?.themeColor,
          }}
        >
          <Row justify={"space-between"} style={{ height: "55px" }}>
            <Col
              style={{
                height: "55px",
                width: `${collapsed ? "75px" : "200px"}`,
              }}
            >
              <span>
                <img
                  src={collapsed ? companylogo1 : companylogo}
                  // src={companylogo}
                  width={collapsed ? 42 : 170}
                  height={55}
                  // onClick={() => setCollapsed(!collapsed)}
                  // onClick={() =>
                  //   navigate(`/books/clients/${clientId}/dashboard`)
                  // }
                  style={{
                    margin: "0px 0px 0px 16px",
                    transitionDuration: "0.18s",
                    cursor: "pointer",
                  }}
                  alt="companylogo1"
                />
              </span>
            </Col>
            <Col
              style={{
                height: "55px",
                width: `calc(100% - ${collapsed ? "75px" : "200px"})`,
              }}
            >
              <Row
                justify={"space-between"}
                style={{ height: "100%" }}
                align="middle"
              >
                <Col>
                  <div
                    style={{
                      cursor: "pointer",
                      height: "50px",
                      // textAlign: "center",
                      alignItems: "center",
                    }}
                    onClick={() => {
                      setCollapsed(!collapsed);
                      setOpenDrawer(true);
                    }}
                  >
                    <MenuIcon
                      active={!collapsed}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                </Col>
                <Col
                  style={{
                    height: "50px",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <Popover
                    content={<ContentUser />}
                    placement="bottomLeft"
                    trigger="click"
                  >
                    {userData?.profilePhoto?.path ? (
                      <div
                        style={{
                          height: "50px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Avatar
                          style={{
                            cursor: "pointer",
                            // marginBottom: "4px",
                            marginRight: "15px",
                          }}
                          size={30}
                          src={userData?.profilePhoto?.path}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          height: "50px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Avatar
                          className="avatar-user"
                          icon={<UserOutlined />}
                          style={{
                            cursor: "pointer",
                            // marginBottom: "4px",
                            marginRight: "15px",
                          }}
                        />
                      </div>
                    )}
                  </Popover>
                </Col>
              </Row>
            </Col>
          </Row>
        </Header>
        <HotkeysProvider>
          <Layout>
            {/* ------- Sider & Drawer ------- */}
            {/* (themeData?.themeData?.silderSize ?? true) ? */}
            {width > 1024 && themeData?.themeData?.silderSize ? (
              <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                breakpoint="lg"
                // onCollapse={(x) => {
                //   setCollapsed(x);
                // }}
                style={{
                  //background: colorBgContainer,
                  position: "fixed",
                  boxShadow: "0px 15px 4px 0px #E4E8F0",
                  height: "100vh",
                  borderRight: "1px solid #E4E8F0",
                  background: themeData.themeData?.themeColor,
                }}
                className="sidertoggle"
              >
                <div>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={[locationUrl]}
                    selectedKeys={[locationUrl]}
                    items={superAdminItems}
                    onClick={(e: any) => selectedMenuItem(e.key)}
                    style={{
                      // top: "px",
                      position: "relative",
                      overflowY: "auto",
                      height: `calc(100vh - 30px)`,
                      border: "none",
                      // background: themeData.themeData?.themeColor,
                      background: "#ffffff",

                      // boxShadow: "2px 1px 5px rgb(81 100 120 / 8%)",
                    }}
                  />
                </div>
              </Sider>
            ) : (
              <Drawer
                className="drawerToggle"
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
                closeIcon={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                      {/* <MenuOutlined
                        style={{
                          fontSize: "20px",
                          paddingLeft: "20px",
                        }}
                      /> */}
                    </div>
                  </div>
                }
                placement="left"
                style={{ width: "200px" }}
              >
                <Menu
                  mode="inline"
                  defaultSelectedKeys={[locationUrl]}
                  selectedKeys={[locationUrl]}
                  items={superAdminItems}
                  onClick={(e: any) => selectedMenuItem(e.key)}
                  style={{
                    // width: "200px",
                    // position: "relative",
                    // overflowY: "auto",

                    // top: "60px",
                    position: "relative",
                    overflowY: "auto",
                    height: `calc(100vh - 60px)`,
                    fontFamily: "'Open Sans','sans-serif'",
                    fontSize: "14px",
                    borderRight: "none",
                    boxShadow: "2px 1px 5px rgb(81 100 120 / 8%)",
                  }}
                />
              </Drawer>
            )}
            <Layout
              style={{
                marginLeft:
                  width <= 1024 || themeData?.themeData?.silderSize !== true
                    ? "0px"
                    : collapsed !== true
                    ? "200px"
                    : "80px",
                transition: "0.2s",
              }}
            >
              {/* ------- Account Content ------- */}
              <Content
                // className="chartdivstyle"
                style={{
                  height: `calc(100vh - 60px)`,
                  overflowY: "hidden",
                  backgroundColor: themeData?.themeData?.darkMode
                    ? ""
                    : "#f7f8fa",
                }}

                // style={{
                //   background: colorBgContainer,
                // }}
              >
                <Card
                  size="small"
                  className="TableCard"
                  style={{
                    justifyContent: "center",
                    margin: "20px 20px",
                    // border: "1px solid #eef2fe",
                    boxShadow: "0px 0px 10px 0px #96A1C84D",
                  }}
                >
                  {props.element}
                </Card>
              </Content>
            </Layout>
          </Layout>
        </HotkeysProvider>
      </ConfigProvider>
    </>
  );
};

export default MainSuperAdminTable;
